import React from 'react';
import { useNavigate } from 'react-router-dom';
import URL from '@/common/routes/Url';
import './css/style.scss';

const Home: React.FC = () => {
  const navigate = useNavigate();
  // const location = useLocation();

  const tologin = () => {
    navigate(URL.signin);
  }

  return (
    <div className='home'>
      <title>次世代ホワイトボード みてリンク</title>

      {/*adobefonts*/}
      {/* Global site tag (gtag.js) - Google Ads: 719112786 */}
      <div className="wrap">
        <header>
          <h1 className="ttl">
            <img src="/manual/sample/images/logo.png" alt="次世代ホワイトボード みてリンク" />
          </h1>
          <ul className="list">
            <li>
              <a href="/signin">ログイン</a>
            </li>
            <li>
              <a href="/home">ホーム</a>
            </li>
            <li>
              <a href="https://si.mitani-corp.co.jp/lp/mitelink-form/">
                お問い合わせ
              </a>
            </li>
            <li>
              <a href="/home/privacy">プライバシーポリシー</a>
            </li>
            <li>
              <a href="/manual/terms.pdf" target='_blank'>
                利用規約
              </a>
            </li>
          </ul>
        </header>
        <div className="mv">
          社員がどこで何をしているか 行動予定は次世代ホワイトボード
          みてリンクですぐ分かる
          <div className="btn">
            <a href="https://si.mitani-corp.co.jp/lp/mitelink-form/">
              <img src="/manual/sample/images/mv_btn.png" alt="無償プランを利用する" />
            </a>
          </div>
        </div>
        <div className="kakuninWrap">
          <h2 className="ttl">在籍確認は、社員の小さなストレス。</h2>
          <div className="beforeBox">
            <div className="ttl">
              <img src="/manual/sample/images/kakunin_subttl1.png" alt="導入前" />
            </div>
            <ul className="list">
              <li>
                <img
                  src="/manual/sample/images/kakunin_img1.png"
                  alt="在籍確認の度に仕事が止まる"
                />
                <p className="txt">在籍確認の度に仕事が止まる</p>
              </li>
              <li>
                <img
                  src="/manual/sample/images/kakunin_img2.png"
                  alt="ホワイトボードが遠くて見えない"
                />
                <p className="txt">ホワイトボードが遠くて見えない</p>
              </li>
              <li>
                <img
                  src="/manual/sample/images/kakunin_img3.png"
                  alt="予定が書かれていないためすぐに回答できない"
                />
                <p className="txt">
                  予定が書かれていないため
                  <br />
                  すぐに回答できない
                </p>
              </li>
              <li>
                <img
                  src="/manual/sample/images/kakunin_img4.png"
                  alt="営業の予定変更の電話を受けて手描きのホワイトボードを直すアシスタント"
                />
                <p className="txt">
                  営業の予定変更の電話を受けて手描きの
                  <br />
                  ホワイトボードを直すアシスタント
                </p>
              </li>
            </ul>
          </div>
          <div className="afterBox">
            <div className="ttl">
              <img src="/manual/sample/images/kakunin_subttl2.png" alt="導入後" />
            </div>
            <ul className="list">
              <li>
                <img
                  src="/manual/sample/images/kakunin_img5.png"
                  alt="大切なお客様へスピーディーに回答"
                />
                <p className="txt">
                  大切なお客様へ
                  <br />
                  スピーディーに回答
                </p>
              </li>
              <li>
                <img
                  src="/manual/sample/images/kakunin_img6.png"
                  alt="自席ですぐ確認！仕事も止まらない！"
                />
                <p className="txt">
                  自席ですぐ確認！
                  <br />
                  仕事も止まらない！
                </p>
              </li>
              <li>
                <img
                  src="/manual/sample/images/kakunin_img7.png"
                  alt="スマートフォン対応なので外出先からでもサクッと更新"
                />
                <p className="txt">
                  スマートフォン対応なので
                  <br />
                  外出先からでもサクッと更新
                </p>
              </li>
            </ul>
          </div>
          <div className="catchBox">
            <div className="catch">
              <img
                src="/manual/sample/images/catch1_ttl.png"
                alt="みてリンクなら、在席状況を漏れなくサクッと確認　行動予定はどこでもサクッと更新"
              />
            </div>
            <ul className="list">
              <li>行動予定表をスマホやパソコンで確認できる</li>
              <li>誰にでも使いやすいシンプルな便利機能が豊富</li>
              <li>組織やチーム独自の利用方法に合わせてカスタマイズ可能</li>
            </ul>
          </div>
        </div>
        {/*kakuninWrap*/}
        <div className="simpleWrap">
          <h2 className="ttl">
            機能がシンプルだから、
            <br />
            分かりやすく、ずっと続けられる。
          </h2>
          <ol className="list">
            <li>
              <h3 className="ttl">ステータス2段階管理</h3>
              <p className="txt">
                ワークスタイルと行動予定を組み合わせることで多彩な働き方に合わせた表現が可能。アイコンやカラーも自由に設定。
              </p>
            </li>
            <li>
              <h3 className="ttl">マイグループ</h3>
              <p className="txt">
                ユーザー毎にメンバーを選択してグルーピング。
                <br />
                メンバーのステータスを一目で把握できます。
              </p>
            </li>
            <li>
              <h3 className="ttl">電話番号タップ発信</h3>
              <p className="txt">スマホであれば番号タップで発信可能</p>
            </li>
            <li>
              <h3 className="ttl">
                <span>有償機能</span>
                <br />
                簡易ステータス変更
              </h3>
              <p className="txt">
                直近の行動予定を履歴として10件保持。
                <br />
                履歴からワンクリックでステータスを即更新。
              </p>
            </li>
            <li>
              <h3 className="ttl">
                <span>有償機能</span>
                <br />
                操作履歴管理
              </h3>
              <p className="txt">
                ログイン、ログアウト、ステータス変更の履歴をCSV出力
                <br />
                ※管理者のみ実行可能な機能です。
              </p>
            </li>
          </ol>
        </div>
        {/*simpleWrap*/}
        <div className="kinouWrap" id="kinou">
          <h2 className="ttl">機能紹介</h2>
          <h3 className="ttl ttl1">ステータス2段階管理</h3>
          <p className="txt">働き方と行動予定を組み合わせてステータス管理</p>
          <ul className="list">
            <li>
              <img
                src="/manual/sample/images/kinou_subttl1_img1.png"
                alt="働き方 出社、行動予定 来客中"
              />
            </li>
            <li>
              <img
                src="/manual/sample/images/kinou_subttl1_img2.png"
                alt="働き方 在宅勤務、行動予定 外出"
              />
            </li>
            <li>
              <img
                src="/manual/sample/images/kinou_subttl1_img3.png"
                alt="働き方 サテライトオフィス、行動予定 WEB会議"
              />
            </li>
          </ul>
          <div className="img1">
            <img
              src="/manual/sample/images/kinou_subttl1_img4.png"
              alt="色やアイコンを自由に組み合わせて設定することができる"
            />
          </div>
          <div className="img2">
            <img
              src="/manual/sample/images/kinou_subttl1_img5.png"
              alt="業務に合わせて自由に設定"
            />
            <img
              src="/manual/sample/images/kinou_subttl1_img6.png"
              alt="カンタン・シンプルな画面でPC操作が苦手な社員でも指導無しでラクラク入力"
            />
          </div>
          <h3 className="ttl ttl2">マイグループ</h3>
          <div className="img3">
            <img
              src="/manual/sample/images/kinou_subttl2_img.png"
              alt="自分でメンバーを選択してグルーピングできる部署を超えたグループも作成可能　例）プロジェクトごとにグループ化 社内報作成チーム、インターン担当"
            />
          </div>
          <div className="box">
            <div className="boxIn">
              <h3 className="ttl ttl3">タップ発信</h3>
              <div className="img4">
                <img
                  src="/manual/sample/images/kinou_subttl3_img.png"
                  alt="タップで即発信できる"
                />
              </div>
            </div>
            <div className="boxIn">
              <h3 className="ttl ttl4">アナウンス</h3>
              <div className="img5">
                <img
                  src="/manual/sample/images/kinou_subttl4_img.png"
                  alt="有償機能 社員への業務案内もみてリンクで！公開範囲も設定できるアナウンス機能搭載"
                />
              </div>
            </div>
          </div>
          <h3 className="ttl ttl5">簡易ステータス変更</h3>
          <div className="img6">
            <img
              src="/manual/sample/images/kinou_subttl5_img.png"
              alt="有償機能 過去に登録したステータスと行先を保持一覧からワンクリックで予定変更できる"
            />
          </div>
          <h3 className="ttl ttl6">操作履歴出力</h3>
          <div className="img6">
            <img
              src="/manual/sample/images/kinou_subttl6_img.png"
              alt="有償機能 ログイン、ログアウト、ステータス変更のログをCSVに出力 簡単に社員の行動履歴を把握できる（管理者向け機能）"
            />
          </div>
        </div>
        {/*kinouWrap*/}
        <div className="katsuyouWrap">
          <h2 className="ttl">みてリンク活用方法</h2>
          <h3 className="ttl">
            みてリンクは使い方次第！いろんな場面で活用できます！
          </h3>
          <div className="box">
            <div className="boxIn">
              <div className="item">
                <h4 className="ttl">
                  <span>有償機能</span>
                  <br />
                  簡易ステータス変更
                </h4>
                <p className="txt">行動予定を複数履歴保持</p>
              </div>
              <div className="item">
                <h4 className="ttl">
                  <span>有償機能</span>
                  <br />
                  操作履歴出力
                </h4>
                <p className="txt">
                  ログイン、ログアウト、ステータス変更の
                  <br />
                  ログをCSVに出力
                </p>
              </div>
            </div>
            <div className="boxIn">
              <h4 className="ttl">勤怠管理を手助け</h4>
              <img src="/manual/sample/images/katsuyou_subttl_img1.png" alt="勤怠管理を手助け" />
              <p className="txt">
                日報・作業報告書作成など業務や勤怠管理に活用できます
              </p>
            </div>
          </div>
          <div className="box">
            <div className="boxIn">
              <div className="item">
                <h4 className="ttl">ステータス2段階管理</h4>
                <p className="txt">働き方と行動予定を組み合わせて表示できる</p>
              </div>
              <div className="item">
                <h4 className="ttl">
                  <span>有償機能</span>
                  <br />
                  操作履歴出力
                </h4>
                <p className="txt">
                  ログイン、ログアウト、ステータス変更の
                  <br />
                  ログをCSVに出力
                </p>
              </div>
            </div>
            <div className="boxIn">
              <h4 className="ttl">働き方改善の一助に</h4>
              <img
                src="/manual/sample/images/katsuyou_subttl_img2.png"
                alt=" 働き方改善の一助に"
              />
              <p className="txt">
                テレワーク実施率など社員の働き方を分析したり、
                <br />
                社員の行動分布に活用できます
              </p>
            </div>
          </div>
          <div className="box">
            <div className="boxIn">
              <div className="item">
                <h4 className="ttl">ステータス2段階管理</h4>
                <p className="txt">働き方と行動予定を組み合わせて表示できる</p>
              </div>
              <div className="item">
                <h4 className="ttl">マイグループ</h4>
                <p className="txt">
                  ユーザー毎に社員をグループ化して一覧表示
                  <br />
                  できる
                </p>
              </div>
            </div>
            <div className="boxIn">
              <h4 className="ttl">社内決裁の円滑化</h4>
              <img src="/manual/sample/images/katsuyou_subttl_img3.png" alt=" 社内決裁の円滑化" />
              <p className="txt">
                部課長や役員をグルーピング、一目で在席状況が確認できる
                <br />
                忙しい上司の在席を見逃さないことで、滞りがちな書類提出
                <br />
                など社内作業をスムーズに進めることができます
              </p>
            </div>
          </div>
          <div className="catchBox">
            <div className="catch">
              <img
                src="/manual/sample/images/catch2_ttl.png"
                alt="みてリンクなら、社員の小さな困り事をサクッと解決"
              />
            </div>
          </div>
        </div>
        {/*katsuyouWrap*/}
        <div className="priceWrap" id="price">
          <h2 className="ttl">料金プラン</h2>
          <div className="box">
            <div className="boxIn">
              <img
                src="/manual/sample/images/plan_free.png"
                alt="FREEフリー 0円／月 登録者 最大30名　広告表示あり　チャットボットサポートあり"
              />
            </div>
            <div className="boxIn">
              <img
                src="/manual/sample/images/plan_standard.png"
                alt="STANDARDスタンダード 110園／月（メンバー1人につき） 登録者 30～無制限（増減は10名単位）広告表示なし　チャットボットサポートあり　アナウンス機能 簡易ステータス変更 操作履歴出力　初期導入指導（オプション）30,000円／2時間　電話サポート（オプション）2,000円／月（平日9:00～17:00"
              />
            </div>
          </div>
        </div>
        {/*priceWrap*/}
        <div className="infoWrap">
          <div className="btn">
            <a href="https://si.mitani-corp.co.jp/lp/mitelink-form/">
              お問い合わせはこちらからどうぞ
            </a>
          </div>
          <div className="flex">
            <div className="box">
              <img src="/manual/sample/images/ftr_logo.png" alt="三谷商事株式会社" />
              <img src="/manual/sample/images/ftr_name.png" alt="情報システム事業部システム部" />
            </div>
            <div className="box2">
              <div className="info">
                <img src="/manual/sample/images/ftr_icon_phone.png" alt="フリーダイヤル" />
                <a href="tel:0120-188-022">0120-188-022</a>
              </div>
              <div className="info2">受付時間 9:00-12:00 13:00-17:00</div>
              <div className="info3">
                <img src="/manual/sample/images/ftr_icon_mail.png" alt="メールアドレス" />
                <a href="mailto:mitelink@mitani-corp.co.jp">
                  mitelink@mitani-corp.co.jp
                </a>
              </div>
            </div>
          </div>
          <div className='footer'>
            <ul className="md-flex">
            <li><a href="/home">ホーム</a></li>
              <li className='ll'><a href="/home/overview">会社概要</a></li>
              <li className='ll'><a href="/home/sct">特定商取引法に基づく表記</a></li>
              <li className='ll'><a href="/home/privacy">プライバシーポリシー</a></li>
              <li className='ll'><a href="/manual/terms.pdf" target='_blank'>利用規約</a></li>
            </ul>
          </div>
        </div>
        {/*infoWrap*/}
      </div>
      {/*wrap*/}
    </div>
  );
}
export default Home;